module.exports = __webpack_public_path__ + "static/img/vuePlugin.ac898d8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/article/vuePlugin.jpeg
// module id = gGSd
// module chunks = 0